// ============================================================
// BASIM EKRANI SABİTLERİ (Faz C, 2026-09-03 — kullanıcı kararı)
//
// TEK YERLEŞİM: ÖSYM kitapçığı (210×290 mm, 2 sütun). Kağıt boyutu / sütun /
// ÖSYM-klasik / header-footer / kapak-OMR toggle'ı / kitapçık türü / görsel
// boyutu / öğrenci çözüm alanı / soru bankası / KDT formatı EKRANDAN KALKTI.
// Üç ürün: TYT denemesi, AYT Sayısal (Sözel hazırlanıyor), Konu testi / genel
// deneme (tek ders). "Yayınevine verilecek" yalnız bir İŞARETTİR (çıktı bölümü).
// Sade akış (2026-09-03, kullanıcı): akordeon adım yok, özet metni yok; seçili
// butonlar belirgin (yardimcilar.secimSinifi).
// ============================================================

export const URUNLER = {
  tyt: {
    id: 'tyt', ad: 'TYT Denemesi', kisa: 'TYT', ikon: '🅰', sinav: 'TYT', toplam: 120,
    dokum: 'Türkçe 40 · Sosyal 20 (5+5+5+5) · Temel Matematik 40 (30+10) · Fen 20 (7+7+6)',
    aciklama: 'Tam ÖSYM TYT denemesi: 120 soru — Türkçe 40 · Sosyal 20 · Temel Matematik 40 · Fen 20. '
      + 'Kapak, açıklama sayfası, arka kapak ve test bölümlü cevap anahtarı ile basılır.',
  },
  ayt_sayisal: {
    id: 'ayt_sayisal', ad: 'AYT Sayısal', kisa: 'AYT Sayısal', ikon: '🔬', sinav: 'AYT', toplam: 80,
    dokum: 'Matematik 40 (30+10) · Fen 40 (14+13+13)',
    aciklama: 'Tam ÖSYM AYT Sayısal denemesi: 80 soru — Matematik 40 · Fen 40. '
      + 'Kapak, açıklama sayfası, arka kapak ve cevap anahtarı ile basılır.',
  },
  // AYT SÖZEL (2026-09-03): motor + format hazır (`AYT_SOZEL`, slot-ders soyutlaması);
  // ürün PASİF — Tarih-1 slotunun havuzu boş (ayt_tarih yalnız 12. sınıf ITA taşıyor).
  // Kazanım evi + üretim hattı kurulunca `pasif: false` (+ hazır çip) ile açılır;
  // fizibilite o güne kadar `uygun:false` döner. Kullanıcı kararı: Tarih-1 için
  // TYT havuzu KULLANILMAZ.
  ayt_sozel: {
    id: 'ayt_sozel', ad: 'AYT Sözel', kisa: 'AYT Sözel', ikon: '📜', sinav: 'AYT_SOZEL', toplam: 80, pasif: true,
    pasifNot: 'Tarih-1 havuzu kurulunca açılır',
    dokum: 'TDE-SB1: Edebiyat 24 · Tarih-1 10 · Coğrafya-1 6 — SB2: Tarih-2 11 · Coğrafya-2 11 · Felsefe Grubu 12 (3+3+3+3) · Din 6',
    aciklama: 'Tam ÖSYM AYT Sözel denemesi: 80 soru — Türk Dili ve Edebiyatı-Sosyal Bilimler-1 (40) + '
      + 'Sosyal Bilimler-2 (40). Motor hazır; Tarih-1 kazanım evi ve havuzu kurulunca açılır.',
  },
  konu: {
    id: 'konu', ad: 'Konu Testi / Genel Deneme', kisa: 'Konu Testi', ikon: '📝', sinav: null, toplam: null,
    aciklama: 'Ders(ler) → kazanım(lar) → soru sayısı → zorluk. Tek ders ÖSYM tek test bloğu olarak; '
      + 'birden fazla ders ÖSYM çok-testli genel deneme (kapak + test başlıkları + test bölümlü cevap '
      + 'anahtarı) olarak basılır. Sorular filtreyle havuzdan çekilir ya da elle seçilir.',
  },
  // SORU BANKASI (2026-10-11, kullanıcı kararları): HTML tasarım (Pegem + yayınevi tasarımları), sunucuda
  // Chromium; testler numara listesiyle elle kurulur; A4. Akıllı dizgi test içinde aynı basamaktaki
  // soruların yerini değiştirerek sayfaları doldurur (kolaydan zora akış korunur).
  soru_bankasi: {
    id: 'soru_bankasi', ad: 'Soru Bankası', kisa: 'Soru Bankası', ikon: '📚', sinav: null, toplam: null,
    aciklama: 'Tasarım → kitap bilgileri → testler (her test: ad + soru numaraları). Her test açılış bandı ve '
      + 'soru haritası, tür etiketli soru kartları ve test karnesiyle; sonda cevap anahtarı + öğrenme çıktısı '
      + 'haritası ve adım adım çözümler. A4, iki sütun.',
  },
};
// LGS (2026-10-20, lgs.esasakademi.com): iki MEB oturumu tam deneme olarak (backend denemeFormat
// LGS_SOZEL / LGS_SAYISAL) + aynı Konu Testi ürünü sinav 'LGS' ile. Kartlar yalnız kendi platformunda.
URUNLER.lgs_sozel = {
  id: 'lgs_sozel', ad: 'LGS Sözel Oturum', kisa: 'LGS Sözel', ikon: '📖', sinav: 'LGS_SOZEL', toplam: 50, formatAdi: 'MEB LGS formatı',
  dokum: 'Türkçe 20 · T.C. İnkılap Tarihi 10 · Din Kültürü 10 · İngilizce 10',
  aciklama: 'LGS sözel oturumu: 50 soru, 75 dakika — Türkçe 20 · İnkılap 10 · Din 10 · İngilizce 10. '
    + '4 şık; kapak, açıklama, arka kapak ve test bölümlü cevap anahtarı ile basılır.',
};
URUNLER.lgs_sayisal = {
  id: 'lgs_sayisal', ad: 'LGS Sayısal Oturum', kisa: 'LGS Sayısal', ikon: '📐', sinav: 'LGS_SAYISAL', toplam: 40, formatAdi: 'MEB LGS formatı',
  dokum: 'Matematik 20 · Fen Bilimleri 20',
  aciklama: 'LGS sayısal oturumu: 40 soru, 80 dakika — Matematik 20 · Fen Bilimleri 20. '
    + '4 şık; kapak, açıklama, arka kapak ve test bölümlü cevap anahtarı ile basılır.',
};
export const URUN_SIRASI = ['tyt', 'ayt_sayisal', 'ayt_sozel', 'konu', 'soru_bankasi'];
export const LGS_URUN_SIRASI = ['lgs_sozel', 'lgs_sayisal', 'konu'];

// Figma "DenemeKapak" kapak tasarımları (2026-10-12, kullanıcı isteği): Konu Testi / Genel Deneme'de
// ÖSYM kapağı yerine ön + arka kapak. Sunucu: texlive-api/kapak + backend lib/kapakTasarim (aynı kimlikler,
// tests/test_kapak_tasarim.py kilitli). Önizleme görseli public/kapak/<id>.png (Figma ekran görüntüsü).
export const KAPAK_TASARIMLARI = [
  { id: 'modern', ad: 'Modern Maarif', aciklama: 'Formül tahtası paneli, ders etiketleri, el yazısı slogan' },
  { id: 'geometrik', ad: 'Geometrik', aciklama: 'Renkli geometrik mozaik, numaralı ders listesi' },
  { id: 'desen', ad: 'Desen', aciklama: 'Çini deseni zemin, sekiz köşeli yıldız amblem, çift çerçeve' },
  { id: 'defter', ad: 'Defter', aciklama: 'Spiralli defter sayfası, yapışkan not kâğıdında dersler' },
  { id: 'harita', ad: 'Bilgi Haritası', aciklama: 'Dersler Maarif merkezli bir ağın düğümleri' },
  // LGS (2026-10-21, kullanıcı onayı): yalnız lgs.* panelinde; LGS oturum denemesinde de seçilir.
  { id: 'yol', ad: 'Lise Yolu', aciklama: 'Testler lise bayrağına giden yolun durakları', lgs: true },
  { id: 'kart', ad: 'Oturum Kartı', aciklama: 'Oturum renginde şerit, soru/süre rakamları, test çizelgesi, öğrenci kuponu', lgs: true },
  { id: 'rozet', ad: 'Rozetler', aciklama: 'Her test simgeli bir rozet; kalın çizgi, sert gölge', lgs: true },
];
// Panelin kipine göre seçilebilen kapak tasarımı (YKS panelinde YKS, lgs.* panelinde LGS tasarımları).
export const kapakTasarimlari = (lgs) => KAPAK_TASARIMLARI.filter((t) => !!t.lgs === !!lgs);

// Soru bankası tasarımları (sunucu: texlive-api/soru_bankasi/tasarim/<id>). Yeni tasarım kullanıcı
// onayından sonra eklenir (backend soruBankasi.TASARIMLAR ile aynı liste).
export const SB_TASARIMLAR = [
  { id: 'pegem', ad: 'Pegem', aciklama: 'Sınıfa göre renk (9 yeşil · 10 lacivert · 11 mercan), kart başlıklı sorular, soru haritası, test karnesi', renk: '#0e8c7f' },
  // Klasik + Canlı: kullanıcı onayı 2026-10-11 (örnek sayfalar gerçek motorla gösterildi)
  { id: 'klasik', ad: 'Klasik', aciklama: 'Lacivert + altın, serif başlıklar (Source Serif), ince çizgiler, çerçeveli kapak, yoğun dizgi', renk: '#1c2b4a' },
  { id: 'canli', ad: 'Canlı', aciklama: 'Çivit + mercan, geometrik sans (Montserrat / Inter), yuvarlak numara rozetleri, renkli test açılışı', renk: '#3d3bb8' },
];
export const SB_TURLER = ['İşlem', 'Günlük yaşam', 'Akıl yürütme', 'Model kurma', 'Tablo', 'Grafik', 'Şekil', 'Öncüllü', 'Bağlam çifti'];
export const SB_TEST_TAVAN = 40;      // test başına soru (sunucu 1-40)
export const SB_TEST_SAYISI = 60;     // kitap başına test (sunucu 1-60, en çok 1200 soru; 2026-10-22: 30 -> 60)
export const SB_BASLANGIC = {
  tasarim: 'pegem', ders: 'Matematik', sinif: '', baslik: '', altBaslik: '', yil: '2026-2027', logoSvg: null,
  // test: { ad, metin (numara listesi), sorular (POST /api/sorular/batch), tur {public_no: tür}, bulunamayan, gecersiz }
  testler: [{ ad: '', metin: '', sorular: [], tur: {}, bulunamayan: [], gecersiz: [] }],
};

// Hazır çip satırı KALKTI (2026-09-03, sade akış — ürün kartlarıyla aynı iş).

// Konu testi zorluk profilleri — deneme panelindeki dört profil + "Karışık".
// Profil → kova kotası (kolay/orta/zor adet) istemcide kurulur (profilKova);
// backend `filtre.zorlukKota` alır (öğretmen zorluk_puan kovaları).
export const ZORLUK_PROFILLERI = [
  { id: 'karisik', l: 'Karışık', t: 'Zorluk kısıtı yok — havuzdan olduğu gibi (öğretmen puanına bakılmaz)', agirlik: null },
  { id: 'dengeli', l: 'Dengeli', t: 'Kolay / orta / zor eşit adet', agirlik: { kolay: 1, orta: 1, zor: 1 } },
  { id: 'kolay', l: 'Kolay ağırlıklı', t: '%50 kolay · %33 orta · %17 zor', agirlik: { kolay: 3, orta: 2, zor: 1 } },
  { id: 'zor', l: 'Zor ağırlıklı', t: '%17 kolay · %33 orta · %50 zor', agirlik: { kolay: 1, orta: 2, zor: 3 } },
  { id: 'tumu_zor', l: 'Tümü zor', t: 'Yalnız zor kovadan (havuz yetmezse ortanın üstünden dolar, rapor edilir)', agirlik: { kolay: 0, orta: 0, zor: 1 } },
];

// Müfredat toggle seçenekleri (App.js filter bar deseni)
export const MUFREDATLAR = [
  { v: '', l: 'Hepsi' },
  { v: 'MEB_2018', l: '2018' },
  { v: 'Maarif_2024', l: 'Maarif' },
];

// Soru ekleme aramasında üretici zorluk ENUM'u (SoruEkleci) — basım kotası değil.
export const ZORLUKLAR = ['kolay', 'orta', 'zor', 'uzman'];
export const ZOOM_DEGERLERI = [50, 75, 100, 125, 150];
export const HIZLI_ADETLER = [10, 20, 40];

// localStorage anahtarları — ANAHTARLAR DEĞİŞMEDİ (eski taslak/şablonlar
// `taslakEsle` ile yükleme anında v2 şemaya çevrilir; depo yerinde değişmez).
export const LS_DRAFT = 'basim_draft_v1';
export const LS_GECMIS = 'basim_gecmis_v1';
export const LS_SABLON = 'basim_sablonlari_v1';
export const TASLAK_SURUM = 2;

export const BASLANGIC_KONU_TEST = {
  sinav: 'TYT',
  ders: '',                // = dersler[0].ders (geriye uyum: başlık/dosya adı)
  // ÇOK DERSLİ (2026-09-03): [{ ders, kazanimlar:[{kod,ad,adet}], adet }] seçim sırasıyla;
  // tek eleman → tek dersli kanal, 2+ → filtre.dersPlani (ÖSYM çok-testli).
  dersler: [],
  kazanimlar: [],          // eski şablon/taslak uyumu (konuTestDersleri türetir)
  adet: 20,                // yeni ders eklenince varsayılan adet
  zorlukProfil: 'karisik',
  // OKUL DENEMESİ süzgeçleri (2026-10-08): sınıf (''|9|10|11), zorluk puan aralığı ('' = sınırsız),
  // bağlam çiftlerini dışla, cevap harfi payı (her harf ≤ %30; varsayılan AÇIK).
  sinif: '',
  puanMin: '',
  puanMax: '',
  baglamHaric: false,
  harfDengesi: true,
  // HAFTA SÜZGECİ (TYMM Öğrenme Kanıtı, 2026-10-09): '' | 1-36 (sınıf seçiliyken; Maarif ister),
  // Coğrafya 11 haftalık saat (2 | 4; DÖP iki plan verir).
  hafta: '',
  cografyaSaat: 2,
};

// Hata mesajı eşlemesi (D7)
export const HATA_MESAJLARI = {
  'pdflatex derleme hatasi': 'Bir veya birden fazla sorunun görseli derlenemedi. Aşağıdaki "✕ Bunları Çıkar" düğmesiyle ilerleyebilirsiniz.',
  'Yetkilendirme tokeni gerekli': 'Oturum süreniz doldu. Lütfen yeniden giriş yapın.',
  'Gecersiz veya suresi dolmus token': 'Oturum süreniz doldu. Sayfayı yenileyip tekrar deneyin.',
  'soruIds veya filtre gerekli': 'Önce sorular seçin veya filtre tanımlayın.',
  'Soru bulunamadi': 'Bu kriterlere uygun soru yok. Filtreleri gevşetin veya başka kaynak deneyin.',
  'Onaylanmis soru bulunamadi': 'Onaylanmış soru bulunamadı. Onay sürecini bekleyin.',
  'Deneme dagilimina uygun onaylanmis soru bulunamadi': 'Deneme dağılımına uygun yeterli onaylı soru yok.',
  'Secilen kazanim/konu ve zorlukta onaylanmis soru bulunamadi': 'Seçilen kazanım/konu ve zorlukta onaylanmış soru yok. Kazanımı genişletin ya da zorluğu "Karışık" yapın.',
};
